<template>
<v-dialog scrollable content-class="fti-dialog-bot-picker" v-model="showBotPicker" max-width="390" persistent no-click-animation>
    <v-card>
        <div class="fti-dialog-header">
            <div class="ml-3">{{$t('botList') | capitalize}}</div>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="toggleBotPicker">
                <v-icon color="#fff">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-layout class="pa-2">
            <input type="text" class="search" :placeholder="$t('search') | capitalize" v-model="search">
        </v-layout>
        <div class="list-bot-content">
            <div class="group group-header" @click="togglePinned">
                Pinned
                <v-spacer></v-spacer>
                <v-icon :class="{active: showPinned}">mdi-chevron-down</v-icon>
            </div>
            <div v-if="showPinned">
                <div v-for="bot in botListPinFilter" :key="bot.code" class="bot" @click="selectBot(bot)">
                    <div class="bot-icon">{{ getBotIconName(bot.name) }}</div>
                    {{ bot.name }}
                    <v-spacer></v-spacer>
                    <v-icon small color="#19AB66" v-if="bot.code === activeBotCode">mdi-check-circle</v-icon>
                    <v-icon color="#FFC400" small class="ml-1">mdi-star</v-icon>
                </div>
            </div>
            <div class="group group-header" @click="toggleNoPin" style="border-top: 1px solid #ededf2">
                Bots
                <v-spacer></v-spacer>
                <v-icon :class="{active: showNoPin}">mdi-chevron-down</v-icon>
            </div>
            <div v-if="showNoPin">
                <div v-for="bot in botListNoPinFilter" :key="bot.code" class="bot" @click="selectBot(bot)">
                    <div class="bot-icon">{{ getBotIconName(bot.name) }}</div>
                    {{ bot.name }}
                    <v-spacer></v-spacer>
                    <v-icon small color="#19AB66" v-if="bot.code === activeBotCode">mdi-check-circle</v-icon>
                </div>
            </div>
        </div>
    </v-card>
</v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import _ from "lodash";
import utils from "@/services/utils"

export default {
    name: "DialogBotPicker",
    data () {
        return {
            showPinned: true,
            showNoPin: true,
            search: '',
            activeBotCode: this.$route.params.botCode || this.$route.params.bot_code
        }
    },
    computed: {
        ...mapState({
            botList: state => state.botList,
            botListPin: state => state.botListPin,
            botListNoPin: state => _.differenceBy(
                state.botList,
                state.botListPin,
                bot => bot.code
            )
        }),
        ...mapState('dialog', ['showBotPicker']),
        botListPinFilter () {
            let search = this.search.trim().toLowerCase();
            return this.botListPin.filter(bot => bot.name.toLowerCase().includes(search))
        },
        botListNoPinFilter () {
            let search = this.search.trim().toLowerCase();
            return this.botListNoPin.filter(bot => bot.name.toLowerCase().includes(search))
        }
    },
    methods: {
        ...mapActions('config', ['getBotConfig']),
        ...mapMutations('dialog', ['toggleBotPicker']),
        ...mapMutations('sideBox', ['hideAllSideBox']),
        ...mapActions('notify',['notifyCustomerProcess']),
        togglePinned () {
            this.showPinned = !this.showPinned
        },
        toggleNoPin () {
            this.showNoPin = !this.showNoPin
        },
        initial(botCode) {
            this.getBotConfig(botCode)
        },
        changeBot(botCode) {
            this.getBotConfig(botCode);
            this.hideAllSideBox()
        },
        getBotIconName: utils.getBotIconName,
        selectBot(bot) {
            if (bot.code !== this.activeBotCode) {
                this.connectNotiChannelsOfBot(bot.code);
                this.changeBot(bot.code);
                this.$router.push(`/bot/${bot.code}/`);
            }
            this.toggleBotPicker();
        },
        connectNotiChannelsOfBot(bot_code) {
            // connect channels notification of bot
            // check if subscribed, > unsubscribe
            if (this.$store.state.channelsNotiBot && this.$store.state.channelsNotiBot.state && this.$store.state.channelsNotiBot.state === "subscribed") {
                this.$store.state.channelsNotiBot.unsubscribe();
            }
            // connect channels notification
            let noti_bot_channel_name = this.$const.SOCKETCLUSTER_NOTI_CHANNEL.APP + bot_code;
            this.$store.state.channelsNotiBot = this.$store.state.scClient.subscribe(noti_bot_channel_name);
            this.$nextTick(function () {
                this.$store.state.channelsNotiBot.watch(data => {
                    this.$store.commit(this.$ActionTypes.NOTIFY_CUSTOMER_CHANNELS, data);
                    this.notifyCustomerProcess(data)
                })
            });
        },
    },
    watch: {
        $route () {
            this.activeBotCode = this.$route.params.botCode || this.$route.params.bot_code
        },
        "$route.params.bot_code": {
            handler(newVal, oldVal) {
                if (newVal && !oldVal) {
                    this.initial(newVal)
                }
            }
        }

    }
}
</script>

<style scoped lang="scss" src="../style/bot-picker.scss"></style>
